/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const CopyInRowButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "table.row.inline_copy" })}
      iconName="control_point_duplicate"
      css={labellessButtonCss}
      {...props}
      dataCy="copy-inline-button"
    />
  );
};

export default CopyInRowButton;
